import { NoopScrollStrategy } from '@angular/cdk/overlay';
import {
  Component,
  ElementRef,
  Inject,
  OnInit,
  ViewChild,
} from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialog,
} from '@angular/material/dialog';
import { Constants } from 'src/app/app.constants';
import { AnalyticsAbstract } from 'src/app/services/analytics/analytics.abstract';
import { RewardDialogComponent } from '../../card/reward-dialog/reward-dialog.component';
import { EmojiDialogComponent } from '../emoji-dialog/emoji-dialog.component';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { BirthdayClubInfoComponent } from '../birthday-club-info/birthday-club-info.component';
import {
  MerchantService,
  AuthService,
  CardService,
} from '../../../services/index';
import { PermissionsService } from 'src/app/services/permissions.service';
import { CardType, StampCard } from 'src/app/models';
import { Promotion } from 'src/app/models/promotion';
import { TwoOptionAlertComponent } from 'src/app/shared/components/two-option-alert/two-option-alert.component';

@Component({
  selector: 'automations_dialog',
  templateUrl: './automations_dialog.component.html',
  styleUrls: ['./automations_dialog.component.css'],
})
export class AutomationsDialogComponent implements OnInit {
  @ViewChild('birthdayRewardSection')
  birthdayRewardSection?: ElementRef<HTMLElement>;

  @ViewChild('birthdayRewardTypeDetailSection')
  birthdayRewardTypeDetailSection?: ElementRef<HTMLElement>;

  promotions: Promotion[] = [];
  error = false;
  saving = false;

  cardsLoading = false;
  automationsLoading = false;

  tabs = ['promotions', 'birthday'];
  selectedIndex = 0;
  selectedTab = 'promotions';
  hidePromotionsTab = false;
  hideBirthdayClubTab = false;

  cursorPosition = 0;

  birthdayClubEnabled = false;
  birthdayForm!: FormGroup;
  birthdayPnMessageFormControl: FormControl = new FormControl();
  birthdayIncludeReward = false;
  birthdayRewardTypeFormControl!: FormControl;
  birthdayCardFormControl!: FormControl;
  birthdayQuantityFormControl!: FormControl;
  birthdayRewards: any[] = [];
  pendingBirthdayCardId: string | null = null;
  pendingBirthdayQuantity: number | null = null;

  hasBirthdayClubAccess = false;
  hasPromotionsAccess = false;

  contentMaxChar = 180;
  canEngage = false;
  whenToSendFormControl!: FormControl;

  promoForm!: FormGroup;
  cardFormControl!: FormControl;
  stampsFormControl!: FormControl;
  cards: StampCard[] = [];
  birthdayPointCards: StampCard[] = [];
  birthdayStampCards: StampCard[] = [];
  birthdayStampOptions: { number: number }[] = [];

  fromDateFormControl: FormControl = new FormControl(
    new Date().toISOString().split('T')[0],
    [Validators.required],
  );

  fromTimeFormControl: FormControl = new FormControl('', [Validators.required]);

  toDateFormControl: FormControl = new FormControl(
    new Date().toISOString().split('T')[0],
    [Validators.required],
  );

  toTimeFormControl: FormControl = new FormControl('', [Validators.required]);

  minDate: string = new Date().toISOString().split('T')[0];

  fromTimes: string[] = [];
  toTimes: string[] = [];

  allTimes: string[] = [
    '00:00',
    '01:00',
    '02:00',
    '03:00',
    '04:00',
    '05:00',
    '06:00',
    '07:00',
    '08:00',
    '09:00',
    '10:00',
    '11:00',
    '12:00',
    '13:00',
    '14:00',
    '15:00',
    '16:00',
    '17:00',
    '18:00',
    '19:00',
    '20:00',
    '21:00',
    '22:00',
    '23:00',
  ];

  options: any[] = [
    { name: 'Day of birthday', value: 0 },
    { name: '1 day before', value: 1 },
    { name: '2 days before', value: 2 },
    { name: '3 days before', value: 3 },
    { name: '4 days before', value: 4 },
    { name: '5 days before', value: 5 },
    { name: '6 days before', value: 6 },
    { name: '7 days before', value: 7 },
  ];

  allBirthdayRewardTypeOptions = [
    { name: 'Give points', value: 'points' },
    { name: 'Give stamps', value: 'stamps' },
    { name: 'Give reward', value: 'reward' },
  ];

  merchantActive = false;

  constructor(
    public matDialogRef: MatDialogRef<AutomationsDialogComponent>,
    public fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private mixpanel: AnalyticsAbstract,
    public dialog: MatDialog,
    private constants: Constants,
    private merchantService: MerchantService,
    private router: Router,
    private authService: AuthService,
    private ps: PermissionsService,
    private cardService: CardService,
  ) {
    this.canEngage = this.ps.permissions.engage.view();

    this.hidePromotionsTab = data?.hidePromotionsTab ?? false;
    this.hideBirthdayClubTab = data?.hideBirthdayClubTab ?? false;
    this.tabs = this.hidePromotionsTab
      ? ['birthday']
      : this.hideBirthdayClubTab
        ? ['promotions']
        : ['promotions', 'birthday'];
    this.selectedIndex =
      this.hidePromotionsTab || this.hideBirthdayClubTab
        ? 0
        : data?.selectedIndex || 0;
    this.selectedTab = this.tabs[this.selectedIndex] ?? this.tabs[0];
  }

  ngOnInit(): void {
    this.merchantActive = this.authService.merchantObj?.active ?? true;

    this.getAutomations();
    this.getCards();

    this.birthdayPnMessageFormControl = new FormControl(
      { value: '', disabled: false },
      Validators.required,
    );

    this.whenToSendFormControl = new FormControl(
      { value: this.options[0], disabled: false },
      Validators.required,
    );

    this.birthdayRewardTypeFormControl = new FormControl({
      value: null,
      disabled: false,
    });

    this.birthdayCardFormControl = new FormControl({
      value: null,
      disabled: false,
    });

    this.birthdayQuantityFormControl = new FormControl({
      value: null,
      disabled: false,
    });

    this.birthdayForm = this.fb.group({
      birthdayPnMessage: this.birthdayPnMessageFormControl,
      birthdayRewardType: this.birthdayRewardTypeFormControl,
      birthdayCard: this.birthdayCardFormControl,
      birthdayQuantity: this.birthdayQuantityFormControl,
    });

    this.cardFormControl = new FormControl(
      { value: '', disabled: false },
      Validators.required,
    );

    this.stampsFormControl = new FormControl({ value: '', disabled: false });

    this.promoForm = this.fb.group({
      card: this.cardFormControl,
      stamps: this.stampsFormControl,
      fromDate: this.fromDateFormControl,
      fromTime: this.fromTimeFormControl,
      toDate: this.toDateFormControl,
      toTime: this.toTimeFormControl,
    });

    this.reset();

    this.fromDateFormControl.valueChanges.subscribe(() => {
      this.filterAvailableTimes();
      this.updateTimeForCurrentDate();
    });

    this.fromTimeFormControl.valueChanges.subscribe(() => {
      this.toDateFormControl.setValue(this.fromDateFormControl.value);
      this.updateAvailableToTimes();
    });

    this.toDateFormControl.valueChanges.subscribe(() => {
      this.updateAvailableToTimes();
    });

    this.toDateFormControl.setValidators([
      Validators.required,
      (control) => {
        const toDate = new Date(control.value);
        const fromDate = new Date(this.fromDateFormControl.value);
        return toDate >= fromDate ? null : { invalidDateRange: true };
      },
    ]);
  }

  get dialogTitle(): string {
    if (this.hidePromotionsTab) {
      return 'Birthday Club';
    }

    if (this.hideBirthdayClubTab) {
      return 'Promotions';
    }

    return 'Campaigns';
  }

  get singleSectionDialog(): boolean {
    return this.hidePromotionsTab || this.hideBirthdayClubTab;
  }

  reset(): void {
    this.cardFormControl.setValue(null);
    this.stampsFormControl.setValue(null);
    this.filterAvailableTimes();
    this.initializeDateAndTimeControls();
    this.updateTimeForCurrentDate();
  }

  updateTimeForCurrentDate(): void {
    this.filterAvailableTimes();

    if (this.fromTimes.length > 0) {
      const fromTime = this.fromTimes[0];
      this.fromTimeFormControl.setValue(fromTime);

      const fromHour = parseInt(fromTime.split(':')[0], 10);
      let toHour = fromHour + 1;

      if (toHour > 23) {
        const nextDay = new Date(this.fromDateFormControl.value);
        nextDay.setDate(nextDay.getDate() + 1);
        const formattedNextDay = nextDay.toISOString().split('T')[0];

        this.toDateFormControl.setValue(formattedNextDay);
        this.toTimeFormControl.setValue('00:00');
      } else {
        this.toDateFormControl.setValue(this.fromDateFormControl.value);
        this.toTimeFormControl.setValue(
          `${toHour.toString().padStart(2, '0')}:00`,
        );
      }

      this.updateAvailableToTimes(); // Important: refresh `toTimes` after setting `fromTime`
    }
  }

  updateAvailableToTimes(): void {
    const fromTime = this.fromTimeFormControl.value;
    const fromDate = this.fromDateFormControl.value;
    const toDate = this.toDateFormControl.value;

    if (!fromTime || !fromDate || !toDate) return;

    const fromDateObj = new Date(fromDate);
    const toDateObj = new Date(toDate);

    const isSameDay = fromDateObj.toDateString() === toDateObj.toDateString();
    const fromHour = parseInt(fromTime.split(':')[0], 10);

    if (isSameDay) {
      // Filter toTimes to be strictly > fromTime on the same day
      this.toTimes = this.allTimes.filter((time) => {
        const hour = parseInt(time.split(':')[0], 10);
        return hour > fromHour;
      });
    } else {
      // If different day, all times are valid for toTime
      this.toTimes = [...this.allTimes];
    }

    // Update selected toTime if invalid
    const currentToHour = parseInt(
      this.toTimeFormControl.value?.split(':')[0] || '0',
      10,
    );

    const firstValid = this.toTimes[0];

    if (!this.toTimes.length || (isSameDay && currentToHour <= fromHour)) {
      this.toTimeFormControl.setValue(firstValid);
    }
  }

  initializeDateAndTimeControls(): void {
    this.fromDateFormControl.setValue(new Date().toISOString().split('T')[0]);
    this.fromTimeFormControl.setValue(this.allTimes[0]);
  }

  getLocalTimeString(dateString: string, timeZone: string): string {
    const date = new Date(dateString);

    const formatter = new Intl.DateTimeFormat('en-GB', {
      hour: '2-digit',
      minute: '2-digit',
      timeZone: timeZone,
      hour12: false,
    });

    const parts = formatter.formatToParts(date);
    const hour = parts.find((part) => part.type === 'hour')?.value;
    const minute = parts.find((part) => part.type === 'minute')?.value;

    return `${hour}:${minute}`;
  }

  createDateInTimezone(dateTimeString: string, timeZone: string): Date {
    // Simple approach: create the date string with timezone info and let the browser parse it
    // This leverages the browser's built-in timezone handling

    // Parse the input
    const [datePart, timePart] = dateTimeString.split('T');
    const [hour, minute] = timePart.split(':');

    // Create a date string that represents the local time in the target timezone
    // We'll use a known reference to calculate the offset
    const referenceUTC = new Date(`${datePart}T12:00:00Z`);

    // Get what 12:00 UTC would be in the target timezone
    const referenceLocal = new Date(
      referenceUTC
        .toLocaleString('en-CA', {
          timeZone: timeZone,
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
          hour12: false,
        })
        .replace(', ', 'T'),
    );

    // Calculate the offset
    const offsetMs = referenceUTC.getTime() - referenceLocal.getTime();

    // Apply this offset to our desired time
    const desiredLocal = new Date(`${datePart}T${hour}:${minute}:00`);
    return new Date(desiredLocal.getTime() + offsetMs);
  }

  filterAvailableTimes(): void {
    const selectedDate = new Date(this.fromDateFormControl.value);
    const today = new Date();

    const maxFromHour = 22; // Can't go past this for fromTimes

    if (selectedDate.toDateString() === today.toDateString()) {
      const currentHour = today.getHours();
      const currentMinutes = today.getMinutes();

      let nextHour = currentHour;
      if (currentMinutes > 0) {
        nextHour = currentHour + 2;
      } else {
        nextHour = currentHour + 1;
      }

      this.fromTimes = this.allTimes.filter((time) => {
        const hour = parseInt(time.split(':')[0], 10);
        return hour >= nextHour && hour <= maxFromHour;
      });
    } else {
      this.fromTimes = this.allTimes.filter((time) => {
        const hour = parseInt(time.split(':')[0], 10);
        return hour <= maxFromHour;
      });
    }
  }

  getCards(): void {
    this.cardsLoading = true;
    this.cardService
      .getCards(100, 0)
      .subscribe({
        next: (res: any) => {
          if (res) {
            const activeCards = res.docs.filter(
              (el: StampCard) => el.active === true,
            );

            this.cards = activeCards;

            this.birthdayPointCards = activeCards.filter(
              (el: StampCard) => el.cardType === CardType.openEndedPoint,
            );

            this.birthdayStampCards = activeCards.filter(
              (el: StampCard) => el.cardType === CardType.stamp,
            );

            activeCards.forEach((card: StampCard) => {
              card.info = card.description;
            });

            this.syncBirthdayCardSelection(true);
          }
        },
        error: (res: HttpErrorResponse) => {
          this.constants.snack(res.error.message);
        },
      })
      .add(() => (this.cardsLoading = false));
  }

  get stampNumbers() {
    return Array.from(
      { length: this.cardFormControl.value?.numberOfStamps },
      (_, i) => i + 1,
    );
  }

  getAutomations(): void {
    this.automationsLoading = true;
    this.merchantService
      .getAutomations(true)
      .subscribe({
        next: (res: any) => {
          if (res) {
            this.promotions = res?.promotions ?? [];
            this.hasBirthdayClubAccess = res.access?.birthday;
            this.hasPromotionsAccess = res.access?.promotions;

            const birthdayClub = res?.automations?.birthdayClub;

            this.birthdayClubEnabled = birthdayClub?.enabled || false;

            if (birthdayClub?.message) {
              this.birthdayPnMessageFormControl.setValue(birthdayClub?.message);
            }

            const birthdayRewardType =
              birthdayClub?.rewardType ||
              (birthdayClub?.reward
                ? 'reward'
                : birthdayClub?.card?.cardType === CardType.openEndedPoint
                  ? 'points'
                  : birthdayClub?.card?.cardType === CardType.stamp
                    ? 'stamps'
                    : null);

            this.birthdayRewards = [];
            this.pendingBirthdayCardId = birthdayClub?.card?._id ?? null;
            this.pendingBirthdayQuantity = birthdayClub?.quantity ?? null;

            if (birthdayRewardType) {
              this.birthdayIncludeReward = true;
              const rewardTypeOption =
                this.getBirthdayRewardTypeOption(birthdayRewardType);

              this.birthdayRewardTypeFormControl.setValue(rewardTypeOption);

              if (birthdayRewardType === 'reward' && birthdayClub?.reward) {
                this.birthdayRewards = [{ reward: birthdayClub?.reward }];
              }

              this.applyBirthdayRewardType(rewardTypeOption, true);
            } else {
              this.birthdayIncludeReward = false;
              this.updateBirthdayRewardValidators();
            }

            const whenToSendOption = this.options.find(
              (el) => el.value === (birthdayClub?.daysBeforeBirthday || 0),
            );
            this.whenToSendFormControl.setValue(whenToSendOption);
          }
        },
        error: (res: HttpErrorResponse) => {
          this.error = true;
          this.constants.snack(res.error.message);
        },
      })
      .add(() => (this.automationsLoading = false));
  }

  savePromotion(): void {
    if (!this.promoForm.valid) {
      this.constants.snack('Please complete all required fields');
      return;
    }

    let data = {
      card: this.cardFormControl.value._id,
      stamps: this.stampsFormControl.value,
      fromDate: this.fromDateFormControl.value,
      fromTime: this.fromTimeFormControl.value,
      toDate: this.toDateFormControl.value,
      toTime: this.toTimeFormControl.value,
    };

    // Use merchant's business timezone instead of browser timezone
    const merchantTimezone =
      this.authService.merchantObj?.timezone || 'Europe/London';

    // Create dates in the merchant's timezone, then convert to UTC for storage
    const fromDate = this.createDateInTimezone(
      `${data.fromDate}T${data.fromTime}:00`,
      merchantTimezone,
    ).toISOString();

    const toDate = this.createDateInTimezone(
      `${data.toDate}T${data.toTime}:00`,
      merchantTimezone,
    ).toISOString();

    this.mixpanel.track(Constants.analytics_keys.createPromotion, {
      Card: data.card.title,
      Stamps: data.stamps,
      Start: fromDate,
      End: toDate,
    });

    this.saving = true;
    this.merchantService
      .createPromotion({
        cardId: data.card,
        value: data.stamps,
        start: fromDate,
        end: toDate,
        timezone: merchantTimezone,
      })
      .subscribe({
        next: (res: Promotion) => {
          if (res) {
            this.constants.snack('Promotion saved');
            this.promotions.push(res);
            this.reset();
          }
        },
        error: (res: HttpErrorResponse) => {
          this.error = true;
          this.constants.snack(res.error.message);
        },
      })
      .add(() => (this.saving = false));
  }

  save(): void {
    if (this.selectedTab !== 'birthday') {
      this.matDialogRef.close();
      return;
    }

    if (!this.birthdayForm.valid && this.birthdayClubEnabled) {
      this.constants.snack('Please complete all required fields');
      return;
    }

    if (this.birthdayIncludeReward && !this.birthdayRewards?.length) {
      if (this.selectedBirthdayRewardType === 'reward') {
        this.constants.snack('Please include at least one reward');
        return;
      }
    }

    if (this.birthdayIncludeReward && !this.selectedBirthdayRewardType) {
      this.constants.snack('Please select a reward type');
      return;
    }

    if (
      this.birthdayIncludeReward &&
      ['points', 'stamps'].includes(this.selectedBirthdayRewardType ?? '') &&
      !this.birthdayCardFormControl.value
    ) {
      this.constants.snack('Please select a card');
      return;
    }

    if (
      this.birthdayIncludeReward &&
      ['points', 'stamps'].includes(this.selectedBirthdayRewardType ?? '') &&
      (this.selectedBirthdayQuantity ?? 0) < 1
    ) {
      this.constants.snack(
        this.selectedBirthdayRewardType === 'points'
          ? 'Please enter the number of points'
          : 'Please select the number of stamps',
      );
      return;
    }

    let data: any = {
      birthdayEnabled: this.birthdayClubEnabled,
      birthdayMessage: undefined,
      birthdayReward: undefined,
      birthdayRewardType: undefined,
      birthdayCard: undefined,
      birthdayQuantity: undefined,
      daysBeforeBirthday: this.whenToSendFormControl.value?.value || 0,
    };

    if (this.birthdayClubEnabled) {
      data.birthdayMessage = this.birthdayPnMessageFormControl.value?.trim();
    }

    if (this.birthdayIncludeReward && this.birthdayRewards?.length) {
      data.birthdayRewardType = this.selectedBirthdayRewardType;

      if (this.selectedBirthdayRewardType === 'reward') {
        data.birthdayReward = this.birthdayRewards[0]?.reward?._id;
      }
    }

    if (
      this.birthdayIncludeReward &&
      ['points', 'stamps'].includes(this.selectedBirthdayRewardType ?? '') &&
      this.birthdayCardFormControl.value
    ) {
      data.birthdayRewardType = this.selectedBirthdayRewardType;
      data.birthdayCard = this.birthdayCardFormControl.value?._id;
      data.birthdayQuantity = this.selectedBirthdayQuantity;
    }

    this.updateBirthdayClub(data);
  }

  updateBirthdayClub(data: any): void {
    this.mixpanel.track(Constants.analytics_keys.updateBirthdayClub, {
      Enabled: data.birthdayEnabled,
    });

    this.saving = true;
    this.merchantService
      .updateBirthdayClub(
        data.daysBeforeBirthday,
        data.birthdayEnabled,
        data.birthdayMessage,
        data.birthdayReward,
        data.birthdayRewardType,
        data.birthdayCard,
        data.birthdayQuantity,
      )
      .subscribe({
        next: (res: any) => {
          if (res) {
            this.constants.snack('Automation saved');
            this.matDialogRef.close();
          }
        },
        error: (res: HttpErrorResponse) => {
          this.error = true;
          this.constants.snack(res.error.message);
        },
      })
      .add(() => (this.saving = false));
  }

  tabChanged(index: any): void {
    let tab = this.tabs[index];

    this.selectedTab = tab;

    this.mixpanel.track(Constants.analytics_keys.selectDashboardTab, {
      Tab: tab,
    });
  }

  openRewardDialog(): void {
    const dialogRef = this.dialog.open(RewardDialogComponent, {
      data: {
        rewardOnly: true,
        exclusions: this.birthdayRewards,
      },
      width: '450px',
      autoFocus: false,
      scrollStrategy: new NoopScrollStrategy(),
    });
    dialogRef.afterClosed().subscribe((data: any) => {
      if (data) {
        this.birthdayRewards.push(data);
      }
    });
  }

  removeReward(item: any): void {
    const index = this.birthdayRewards.findIndex((el) => el === item);
    if (index !== -1) {
      this.birthdayRewards.splice(index, 1);
    }
  }

  openEmojiPicker(): void {
    this.mixpanel.track(Constants.analytics_keys.openEmojiPicker);

    const dialogRef = this.dialog.open(EmojiDialogComponent, {
      autoFocus: false,
      scrollStrategy: new NoopScrollStrategy(),
    });

    dialogRef.afterClosed().subscribe((data) => {
      if (data?.emoji) {
        this.insertEmojiAtCursor(data.emoji);
      }
    });
  }

  insertEmojiAtCursor(emoji: string) {
    const currentValue = this.birthdayPnMessageFormControl.value;
    const newValue =
      currentValue.slice(0, this.cursorPosition) +
      emoji +
      currentValue.slice(this.cursorPosition);
    this.birthdayPnMessageFormControl.setValue(newValue);
  }

  updateCursorPosition(event: any) {
    this.cursorPosition = event.target.selectionStart;
  }

  toggleReward(): void {
    this.birthdayIncludeReward = !this.birthdayIncludeReward;

    if (!this.birthdayIncludeReward) {
      this.birthdayRewards = [];
      this.pendingBirthdayCardId = null;
      this.pendingBirthdayQuantity = null;
      this.birthdayCardFormControl.setValue(null);
      this.birthdayQuantityFormControl.setValue(null);
    } else {
      const rewardType = this.birthdayRewardTypeFormControl.value ?? null;
      this.birthdayRewardTypeFormControl.setValue(rewardType);
      this.applyBirthdayRewardType(rewardType);
    }

    this.updateBirthdayRewardValidators();

    if (this.birthdayIncludeReward) {
      setTimeout(() => {
        this.birthdayRewardSection?.nativeElement.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      }, 0);
    }
  }

  seePlans(): void {
    this.matDialogRef.close();
    this.router.navigate([Constants.routes.plans]);
  }

  get infoBoxBodyPromos(): string {
    return `Create time-limited promotions that automatically give extra stamps (or points) per scan on selected loyalty cards. <i>Promos will start and end at the exact dates and times you set</i>.`;
  }

  get infoBoxBody() {
    return `Enable Birthday Club to schedule automated push notifications and birthday bonuses to be sent to your customers on or before their birthday. <i>Push notifications will be sent at 9am on the day selected</i>`;
  }

  get titlePromotions(): string {
    return this.canEngage
      ? 'Promotions are only available on Growth plans'
      : 'Promotions can only be managed by the Merchant Admin';
  }

  get subtitlePromotions(): string {
    return this.canEngage
      ? `Upgrade now to benefit from this automation to schedule extra stamp and points promotions`
      : `Please contact the Merchant Administrator to set up Promotions`;
  }

  get title(): string {
    return this.canEngage
      ? 'Birthday Club is only available on Growth plans'
      : 'Birthday Club can only be managed by the Merchant Administrator';
  }

  get subtitle(): string {
    return this.canEngage
      ? `Upgrade now to benefit from this automation to schedule automated
            push notifications and birthday bonuses to be sent to your customers on their
            birthday`
      : `Please contact the Merchant Administrator to set up Birthday Club`;
  }

  openBirthdayInfoDialog(): void {
    this.dialog.open(BirthdayClubInfoComponent, {
      data: {},
      maxWidth: '600px',
      autoFocus: false,
      panelClass: 'custom-dialog',
      scrollStrategy: new NoopScrollStrategy(),
    });
  }

  insertCustomerNameAtCursor(): void {
    const currentValue = this.birthdayPnMessageFormControl.value;
    const newValue =
      (currentValue ?? '').slice(0, this.cursorPosition) +
      '[customer_name]' +
      (currentValue ?? '').slice(this.cursorPosition);
    this.birthdayPnMessageFormControl.setValue(newValue);
  }

  get promoSummary(): string | null {
    if (
      !this.cardFormControl.value ||
      !this.stampsFormControl.value ||
      !this.fromDateFormControl.value ||
      !this.fromTimeFormControl.value ||
      !this.toDateFormControl.value ||
      !this.toTimeFormControl.value
    ) {
      return null; // Don't show summary until all fields are filled
    }

    const stamps = this.stampsFormControl.value;
    const fromDate = this.fromDateFormControl.value;
    const fromTime = this.fromTimeFormControl.value;
    const toDate = this.toDateFormControl.value;
    const toTime = this.toTimeFormControl.value;

    const fromDateStr = this.formatFriendlyDate(new Date(fromDate));
    const toDateStr = this.formatFriendlyDate(new Date(toDate));

    const isStamps = this.cardFormControl.value.cardType === CardType.stamp;

    return `📣 ${stamps} ${isStamps ? 'stamp' : 'point'}${
      stamps > 1 ? 's' : ''
    } per scan between ${fromDateStr} ${fromTime} and ${toDateStr} ${toTime} ${
      this.promoDuration
    }`;
  }

  formatFriendlyDate(date: Date): string {
    const day = date.getDate();
    const month = date.toLocaleString('default', { month: 'long' });
    const year = date.getFullYear();

    const getOrdinal = (n: number) => {
      if (n > 3 && n < 21) return 'th';
      switch (n % 10) {
        case 1:
          return 'st';
        case 2:
          return 'nd';
        case 3:
          return 'rd';
        default:
          return 'th';
      }
    };

    return `${day}${getOrdinal(day)} ${month} ${year}`;
  }

  get promoDuration(): string | null {
    if (
      !this.fromDateFormControl.value ||
      !this.fromTimeFormControl.value ||
      !this.toDateFormControl.value ||
      !this.toTimeFormControl.value
    ) {
      return null;
    }

    const start = new Date(
      `${this.fromDateFormControl.value}T${this.fromTimeFormControl.value}:00`,
    );
    const end = new Date(
      `${this.toDateFormControl.value}T${this.toTimeFormControl.value}:00`,
    );

    return this.getPromoDurationString(start, end);
  }

  get selectedBirthdayRewardType(): string | null {
    return this.birthdayRewardTypeFormControl.value?.value ?? null;
  }

  get birthdayCardOptions(): StampCard[] {
    if (this.selectedBirthdayRewardType === 'points') {
      return this.birthdayPointCards;
    }

    if (this.selectedBirthdayRewardType === 'stamps') {
      return this.birthdayStampCards;
    }

    return [];
  }

  get birthdayCardLabel(): string {
    return this.selectedBirthdayRewardType === 'points'
      ? 'Points card'
      : 'Stamp card';
  }

  get birthdayQuantityLabel(): string {
    return this.selectedBirthdayRewardType === 'points' ? 'Points' : 'Stamps';
  }

  get selectedBirthdayQuantity(): number | null {
    if (this.selectedBirthdayRewardType === 'stamps') {
      return this.birthdayQuantityFormControl.value?.number ?? null;
    }

    const value = this.birthdayQuantityFormControl.value;
    return value == null || value === '' ? null : Number(value);
  }

  getBirthdayRewardTypeOption(value?: string | null): any {
    return (
      this.allBirthdayRewardTypeOptions.find(
        (option) => option.value === value,
      ) ?? null
    );
  }

  get birthdayRewardTypeOptions(): any[] {
    const selectedType = this.selectedBirthdayRewardType;
    return this.allBirthdayRewardTypeOptions.filter((option) => {
      if (option.value === 'reward') {
        return true;
      }

      if (option.value === 'points') {
        return this.birthdayPointCards.length > 0 || selectedType === 'points';
      }

      if (option.value === 'stamps') {
        return this.birthdayStampCards.length > 0 || selectedType === 'stamps';
      }

      return false;
    });
  }

  onBirthdayRewardTypeSelected(option: any): void {
    this.applyBirthdayRewardType(option);

    setTimeout(() => {
      this.birthdayRewardTypeDetailSection?.nativeElement.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    }, 0);
  }

  applyBirthdayRewardType(option: any, preserveSelection = false): void {
    const selectedType = option?.value ?? null;

    if (selectedType !== 'reward') {
      this.birthdayRewards = [];
    }

    if (selectedType === 'reward') {
      this.birthdayCardFormControl.setValue(null);
      this.birthdayQuantityFormControl.setValue(null);
      this.pendingBirthdayCardId = null;
      this.pendingBirthdayQuantity = null;
    } else {
      this.syncBirthdayCardSelection(preserveSelection);
    }

    this.updateBirthdayRewardValidators();
  }

  updateBirthdayRewardValidators(): void {
    if (this.birthdayIncludeReward) {
      this.birthdayRewardTypeFormControl.setValidators([Validators.required]);
    } else {
      this.birthdayRewardTypeFormControl.clearValidators();
    }

    if (
      this.birthdayIncludeReward &&
      ['points', 'stamps'].includes(this.selectedBirthdayRewardType ?? '')
    ) {
      this.birthdayCardFormControl.setValidators([Validators.required]);
      this.birthdayQuantityFormControl.setValidators(
        this.selectedBirthdayRewardType === 'points'
          ? [Validators.required, Validators.min(1)]
          : [Validators.required],
      );
    } else {
      this.birthdayCardFormControl.clearValidators();
      this.birthdayQuantityFormControl.clearValidators();
      this.birthdayQuantityFormControl.setValue(null);
    }

    this.birthdayRewardTypeFormControl.updateValueAndValidity({
      emitEvent: false,
    });
    this.birthdayCardFormControl.updateValueAndValidity({ emitEvent: false });
    this.birthdayQuantityFormControl.updateValueAndValidity({
      emitEvent: false,
    });
  }

  syncBirthdayCardSelection(preserveSelection = false): void {
    const options = this.birthdayCardOptions;
    const currentValue = this.birthdayCardFormControl.value;
    const targetId = preserveSelection
      ? (this.pendingBirthdayCardId ?? currentValue?._id)
      : currentValue?._id;

    let nextValue =
      options.find((card) => card._id === targetId) ??
      (options.length === 1 ? options[0] : null);

    if (!preserveSelection && currentValue && !nextValue) {
      nextValue = null;
    }

    this.birthdayCardFormControl.setValue(nextValue);
    this.pendingBirthdayCardId =
      nextValue?._id ?? (preserveSelection ? (targetId ?? null) : null);
    this.syncBirthdayQuantitySelection(preserveSelection);
  }

  onBirthdayCardSelected(): void {
    this.pendingBirthdayCardId =
      this.birthdayCardFormControl.value?._id ?? null;
    this.syncBirthdayQuantitySelection(false);
  }

  syncBirthdayQuantitySelection(preserveSelection = false): void {
    if (this.selectedBirthdayRewardType === 'points') {
      const currentValue = this.birthdayQuantityFormControl.value;
      const nextValue = preserveSelection
        ? (this.pendingBirthdayQuantity ?? currentValue)
        : currentValue;

      this.birthdayQuantityFormControl.setValue(nextValue ?? null);
      this.pendingBirthdayQuantity = nextValue ?? null;
      return;
    }

    if (this.selectedBirthdayRewardType === 'stamps') {
      const maxStamps = this.birthdayCardFormControl.value?.numberOfStamps ?? 0;
      this.birthdayStampOptions = Array.from({ length: maxStamps }, (_, i) => ({
        number: i + 1,
      }));

      const currentValue = this.birthdayQuantityFormControl.value;
      const targetNumber = preserveSelection
        ? (this.pendingBirthdayQuantity ?? currentValue?.number)
        : currentValue?.number;

      const nextValue =
        this.birthdayStampOptions.find(
          (option) => option.number === targetNumber,
        ) ??
        (this.birthdayStampOptions.length === 1
          ? this.birthdayStampOptions[0]
          : null);

      this.birthdayQuantityFormControl.setValue(nextValue);
      this.pendingBirthdayQuantity =
        nextValue?.number ??
        (preserveSelection ? (targetNumber ?? null) : null);
      return;
    }

    this.birthdayStampOptions = [];
    this.birthdayQuantityFormControl.setValue(null);
    this.pendingBirthdayQuantity = null;
  }

  get livePromotions(): Promotion[] {
    const now = new Date();
    return this.promotions
      .filter(
        (p) => new Date(p.start ?? '') <= now && new Date(p.end ?? '') >= now,
      )
      .sort(
        (a, b) =>
          new Date(a.end ?? '').getTime() - new Date(b.end ?? '').getTime(),
      ); // Soonest expiry first
  }

  get upcomingPromotions(): Promotion[] {
    const now = new Date();
    return this.promotions
      .filter((p) => new Date(p.start ?? '') > now)
      .sort(
        (a, b) =>
          new Date(a.start ?? '').getTime() - new Date(b.start ?? '').getTime(),
      );
  }

  get expiredPromotions(): Promotion[] {
    const now = new Date();
    return this.promotions
      .filter((p) => new Date(p.end ?? '') < now)
      .sort(
        (a, b) =>
          new Date(b.end ?? '').getTime() - new Date(a.end ?? '').getTime(),
      ); // Most recently expired first
  }

  getPromoTitle(promo: Promotion): string {
    if (typeof promo.card === 'object' && promo.card?.title) {
      return promo.card.title;
    }
    return 'Promotion';
  }

  getPromoSummary(promo: Promotion): string {
    const stamps = promo.value ?? 1;
    const timezone = promo.timezone ?? 'Europe/London';

    const from = new Date(promo.start ?? '');
    const to = new Date(promo.end ?? '');

    const friendlyStart = this.formatFriendlyDate(new Date(from ?? ''));
    const friendlyEnd = this.formatFriendlyDate(new Date(to ?? ''));
    const startTime = this.getLocalTimeString(from.toISOString(), timezone);
    const endTime = this.getLocalTimeString(to.toISOString(), timezone);

    const isPoints = promo?.type === CardType.point || promo?.type === CardType.openEndedPoint;

    return `📣 ${stamps} ${isPoints ? 'point' : 'stamp'}${
      stamps > 1 ? 's' : ''
    } per scan between ${friendlyStart} ${startTime} and ${friendlyEnd} ${endTime} ${this.getPromoDurationString(
      from,
      to,
    )}`;
  }

  getPromoDurationString(start: Date, end: Date): string {
    const ms = end.getTime() - start.getTime();
    if (ms <= 0) return '(Invalid time range)';

    const totalHours = Math.floor(ms / (1000 * 60 * 60));
    const days = Math.floor(totalHours / 24);
    const hours = totalHours % 24;

    const parts = [];
    if (days) parts.push(`${days} day${days > 1 ? 's' : ''}`);
    if (hours) parts.push(`${hours} hour${hours > 1 ? 's' : ''}`);

    return parts.length ? `(${parts.join(', ')})` : '(Less than 1 hour)';
  }

  deletePromotion(promo: Promotion): void {
    const dialogRef = this.dialog.open(TwoOptionAlertComponent, {
      data: {
        title: 'Confirm',
        body: `Are you sure you want to cancel the promotion for "${this.getPromoTitle(
          promo,
        )}"?`,
        buttonOne: 'Cancel',
        buttonTwo: 'Yes',
      },
      scrollStrategy: new NoopScrollStrategy(),
      autoFocus: false,
      width: '350px',
      disableClose: true,
      panelClass: 'custom-dialog',
    });
    dialogRef.afterClosed().subscribe((option: number) => {
      if (option == 1) {
        this.saving = true;
        this.merchantService
          .deletePromotion(promo._id ?? '')
          .subscribe({
            next: () => {
              this.promotions = this.promotions.filter(
                (el) => el._id !== promo._id,
              );
              this.constants.snack('Promotion deleted');
            },
            error: (res: HttpErrorResponse) => {
              this.error = true;
              this.constants.snack(res.error.message);
            },
          })
          .add(() => (this.saving = false));
      }
    });
  }

  get loading(): boolean {
    return this.cardsLoading || this.automationsLoading;
  }
}
